// extracted by mini-css-extract-plugin
export var wordContainer = "_sh-0";